"use strict";

exports.__esModule = true;
exports.StyledInputWrapper = exports.StyledInput = exports.StyledIconCheckedWrapper = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fadeIn = _interopRequireDefault(require("../../../animations/keyframes/fadeIn"));

var _polished = require("polished");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const getWrapperStyles = props => {
  switch (props.inline) {
    case true:
      return `
                position: relative;
                display: flex;
                width: auto;
                margin-right: ${props.theme.space[6]};
            `;

    default:
      return `
                position: relative;
                display: block;
                width: 100%;
            `;
  }
};

const hasError = ({
  meta,
  readOnly
}) => {
  if (readOnly || !meta) return false;
  const {
    touched,
    error
  } = meta;
  return touched && error;
};

const getTypeStyles = props => {
  switch (props.type) {
    case 'checkbox':
    case 'radio':
      return `
                display: inline-block;
                opacity: 0;
                z-index: 1;
                width: 30px;
                height: 30px;
                margin: 0;
                &:checked {
                    outline: none !important;
                }
                &:focus,
                &:hover,
                &:active {
                    outline: none !important;
                }
            `;

    default:
      //text
      return `
                display: block;
                width: 100%;
                font-size: ${props.theme.fontSizes[4]};
                padding: ${props.theme.space[4]} ${props.theme.space[5]};
                color: ${hasError(props) ? props.theme.colors.input.text.error.text : props.theme.colors.input.text.text};
                background-color: ${hasError(props) ? props.theme.colors.input.text.error.background : props.theme.colors.input.text.background};
                line-height: ${props.theme.lineHeights.input};
                padding: .7rem .9rem;
                background-clip: padding-box;
                border: 1px solid ${hasError(props) ? props.theme.colors.input.text.error.border : props.theme.colors.input.text.border};
                border-radius: ${props.theme.borderRadius.small};

                &:focus {
                    background-color: ${hasError(props) ? props.theme.colors.input.text.focus.error.background : props.theme.colors.input.text.focus.background};
                    border-color: ${hasError(props) ? props.theme.colors.input.text.focus.error.border : props.theme.colors.input.text.focus.border};
                }

                &::-ms-input-placeholder {
                    opacity: 0.6;
                }

                &::-moz-placeholder {
                    opacity: 0.6;
                }

                &::-webkit-input-placeholder {
                    opacity: 0.6;
                }
                
                &::placeholder {
                    opacity: 0.6;
                }
            `;
  }
};

const StyledInputWrapper = _styledComponents.default.div`
    ${props => getWrapperStyles(props)}
`;
exports.StyledInputWrapper = StyledInputWrapper;
const StyledInput = _styledComponents.default.input`
    ${props => getTypeStyles(props)}
`;
exports.StyledInput = StyledInput;
const StyledIconCheckedWrapper = _styledComponents.default.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    background-color: ${props => props.checked ? `${props.theme.colors.input.checkbox.checked.background}` : `${props.theme.colors.input.checkbox.background}`};
    border: 2px solid ${props => props.checked ? `${props.theme.colors.input.checkbox.checked.border}` : `${props.theme.colors.input.checkbox.border}`};
    border-radius: ${props => props.theme.borderRadius.small};
    transition: all 0.25s ease-in-out;
    animation: ${_fadeIn.default} 0.75s;

    svg {
        opacity: ${props => props.checked ? `1` : `0`};
        position: absolute;
        top: 5px;
        left: 5px;
        width: 16px;
        height: 16px;
        transition: opacity 0.25s ease-in-out ${props => props.checked ? `0.25s` : `0`};
        
        path {
            fill: ${props => props.theme.colors.input.checkbox.checked.tickIcon};
        }
    }
`;
exports.StyledIconCheckedWrapper = StyledIconCheckedWrapper;